"use client";

import { Pagination } from "@litonarefin/components/Blog/Pagination";
import { useEffect, useState } from "react";

const PER_PAGE = 10;

function PaginationWrapper({
  path = "blog-archive",
  query = "",
  totalPosts,
  activePageNum,
  totalPages,
}) {
  const [activePage, setActivePage] = useState(1);
  const [nextPage, setNextPage] = useState(1);
  const [prevPage, setPrevPage] = useState(0);
  const [totalPage, setTotalPage] = useState(null);

  useEffect(() => {
    setTotalPage(Math.ceil(totalPosts / PER_PAGE));
  }, [totalPosts]);

  // prev/next must follow the page the URL actually landed on, otherwise a
  // direct /page/7/ hit keeps them at their page-1 defaults and the arrows
  // point at the wrong pages (or the prev arrow disappears entirely).
  useEffect(() => {
    const current = !!activePageNum ? +activePageNum : 1;
    setActivePage(current);
    setNextPage(current);
    setPrevPage(current - 1);
  }, [activePageNum]);

  return (
    <div className="jlt-mt-16">
      <Pagination
        href={path}
        query={query}
        prevPage={prevPage}
        setPrevPage={setPrevPage}
        nextPage={nextPage}
        setNextPage={setNextPage}
        activePage={activePage}
        setActivePage={setActivePage}
        totalPage={totalPage}
      />
    </div>
  );
}

export default PaginationWrapper;
